/**
 * Where to send someone who needs People Reports. Lapsed subscribers get the
 * reactivate page for its winback copy and one-click renew; everyone else gets
 * the subscribe page, which is written for a first purchase.
 * @param {object} [opts={}]
 * @param {boolean} [opts.hasHistory=false] Previously held a People Reports sub.
 * @returns {object} vue-router route config
 */
const getPeopleSubscriptionRoute = (opts = {}) =>
  opts.hasHistory
    ? { name: 'dashboard-reactivate' }
    : { name: 'dashboard-subscribe', params: { type: 'people' } };

export default getPeopleSubscriptionRoute;
